import React from "react";
import OrdersList from "../../../components/AdminComponents/Orders";

const Orders = () => {
  return (
    <div className="flex h-full">
      <OrdersList />
    </div>
  );
};

export default Orders;
